import { render, staticRenderFns } from "./UploadImages.vue?vue&type=template&id=0f807648&scoped=true&"
import script from "./UploadImages.vue?vue&type=script&lang=js&"
export * from "./UploadImages.vue?vue&type=script&lang=js&"
import style0 from "./UploadImages.vue?vue&type=style&index=0&id=0f807648&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f807648",
  null
  
)

export default component.exports